export default __webpack_public_path__ + "static/media/space orange.23c55944.png";